import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Users, Monitor, Phone, MapPin, FileText, Store, DollarSign } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function RevAcomodadoPublicoPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${API}/api/rev-acomodados/publico/${token}`);
        setData(res.data);
      } catch {
        setError("Link invalido ou revenda nao encontrada");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [token]);

  if (loading) return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin" />
    </div>
  );

  if (error) return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <Card className="max-w-md w-full mx-4"><CardContent className="p-8 text-center"><Store className="w-12 h-12 mx-auto mb-4 text-muted-foreground opacity-50" /><p className="text-muted-foreground">{error}</p></CardContent></Card>
    </div>
  );

  return (
    <div className="min-h-screen bg-background p-4 sm:p-8">
      <div className="max-w-4xl mx-auto space-y-6">
        {/* Header */}
        <Card>
          <CardContent className="p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-3 rounded-xl bg-primary/10"><Store className="w-8 h-8 text-primary" /></div>
              <div>
                <h1 className="text-2xl font-bold">{data.nome}</h1>
                <p className="text-sm text-muted-foreground">Revenda Acomodado</p>
              </div>
            </div>
            <div className="grid grid-cols-3 gap-4">
              <div className="p-3 rounded-lg bg-blue-500/10 text-center">
                <p className="text-xs text-muted-foreground">Total Clientes</p>
                <p className="text-2xl font-bold text-blue-400">{data.total_clientes}</p>
              </div>
              <div className="p-3 rounded-lg bg-emerald-500/10 text-center">
                <p className="text-xs text-muted-foreground">Total Dispositivos</p>
                <p className="text-2xl font-bold text-emerald-400">{data.total_dispositivos}</p>
              </div>
              <div className="p-3 rounded-lg bg-amber-500/10 text-center">
                <p className="text-xs text-muted-foreground">Soma Total</p>
                <p className="text-2xl font-bold text-amber-400">R$ {Number(data.soma_valor || 0).toFixed(2)}</p>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Clientes List */}
        <Card>
          <CardHeader><CardTitle className="text-lg flex items-center gap-2"><Users className="w-5 h-5 text-primary" /> Clientes ({data.clientes?.length || 0})</CardTitle></CardHeader>
          <CardContent>
            {(!data.clientes || data.clientes.length === 0) ? (
              <p className="text-center text-muted-foreground py-8">Nenhum cliente cadastrado</p>
            ) : (
              <div className="space-y-3">
                {data.clientes.map((c) => (
                  <div key={c.id} className="p-4 rounded-lg border border-border/50 bg-muted/20">
                    <div className="flex items-center gap-2 mb-2">
                      <Users className="w-4 h-4 text-primary" />
                      <span className="font-semibold">{c.nome}</span>
                      <Badge variant="secondary" className="gap-1 text-xs"><Monitor className="w-3 h-3" />{c.quantidade_dispositivos}</Badge>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 text-sm text-muted-foreground">
                      {c.telefone && <div className="flex items-center gap-2"><Phone className="w-3.5 h-3.5" />{c.telefone}</div>}
                      {c.endereco && <div className="flex items-center gap-2"><MapPin className="w-3.5 h-3.5" />{c.endereco}</div>}
                      {c.codigo_launcher && <div className="flex items-center gap-2"><FileText className="w-3.5 h-3.5" /><span className="font-mono text-blue-400">{c.codigo_launcher}</span></div>}
                    </div>
                    {c.observacao && <p className="mt-2 text-xs text-muted-foreground bg-muted/50 p-2 rounded">{c.observacao}</p>}
                  </div>
                ))}
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
